import XButton from '../common/XButton';

const DeleteNoteButton = ({ onClick }) => {
    return (
        <XButton variant="close" className="mr-2" onClick={onClick} aria-label="Delete note">
            <i className="fas fa-trash-alt"></i>
        </XButton>
    );
};

export default DeleteNoteButton;
